
const rts = {
  handleSetPageData: 'handleSetPageData',
  handleItemDataCounts: 'handleItemDataCounts',
}

export const pageDataReducer = (state, action) => {

  const { itemDataCounts } = state
  const { type } = action

  switch (type) {

    case rts.handleSetPageData:
      const { pageDataResults } = action
      return { ...state, pageDataRetrieved: true, ...pageDataResults }

    case rts.handleItemDataCounts:
      itemDataCounts[action.uivi] = action.dataCount
      return { ...state, itemDataCounts }

    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return { ...state }

    default:
      return { ...state }
  }
}

export const pageDataInitialState = (initState) => {
  return { ...initState, itemDataCounts: {} }
};

export const pageDataHandlers = (dispatch) => {
  return {
    handleSetPageData: (pageDataResults) => { dispatch({ type: rts.handleSetPageData, dispatch, pageDataResults }) },
    handleItemDataCounts: (uivi, itemKey, dataCount) => { dispatch({ type: rts.handleItemDataCounts, dispatch, uivi, itemKey, dataCount }) },
  }
}
